const ForWhom = () => {
  const formWhom = document.querySelector('.for-whom')
  const button = formWhom.querySelectorAll('button')

  button.forEach((el) => {
    el.addEventListener('click', function (event) {
      event.preventDefault()
      const id = this.dataset.item

      formWhom.querySelector('.nav-list .active').classList.remove('active')
      formWhom.querySelector('.items .active').classList.remove('active')

      formWhom.querySelector(`#${id}`).classList.add('active')
      this.classList.add('active')
    })
  })
}

export default ForWhom
